import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";
import { useNavigate } from "react-router-dom";

const Navbar = ({ openModal }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate(); // Hook for navigation

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  // Handle scrolling to change navbar background
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close drawer on navigation
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      {/* Logo */}
      <Link to="/">
        <img src="/images/logo.png" alt="Taxi Service Logo" className="logo"/>
      </Link>

      {/* Navigation Links */}
      <ul className="navbar-list">
        <li className={location.pathname === "/" ? "active" : ""}>
          <Link to="/">Home</Link>
        </li>
        <li className={location.pathname === "/packages" ? "active" : ""}>
          <Link to="/packages">Packages</Link>
        </li>
        {/* <li className={location.pathname === "/shop" ? "active" : ""}>
          <Link to="/shop">Shop</Link>
        </li> */}
        <li className={location.pathname === "/about-us" ? "active" : ""}>
          <Link to="/about-us">About Us</Link>
        </li>
        <li className={location.pathname === "/contact-us" ? "active" : ""}>
          <Link to="/contact-us">Contact Us</Link>
        </li>
      </ul>

      {/* Book Button */}
      <div className="navbar-button">
      <button onClick={() => navigate("/booking")}>Book a Taxi</button>
      </div>

      {/* Mobile Menu Icon */}
      <div
        className="menu-icon"
        onClick={toggleDrawer}
        role="button"
        aria-label="Toggle navigation menu"
      >
        ☰
      </div>

      {/* Drawer */}
      <div className={`drawer ${isDrawerOpen ? "open" : ""}`}>
        {/* Close Drawer Icon */}
        <div
          className="close-drawer-icon"
          onClick={closeDrawer}
          role="button"
          aria-label="Close navigation menu"
        >
          &times;
        </div>

        <ul className="drawer-list">
          <li
            onClick={closeDrawer}
            className={location.pathname === "/" ? "active" : ""}
          >
            <Link to="/">Home</Link>
          </li>
          <li
            onClick={closeDrawer}
            className={location.pathname === "/packages" ? "active" : ""}
          >
            <Link to="/packages">Packages</Link>
          </li>
          <li
            onClick={closeDrawer}
            className={location.pathname === "/shop" ? "active" : ""}
          >
            <Link to="/shop">Shop</Link>
          </li>
          <li
            onClick={closeDrawer}
            className={location.pathname === "/about-us" ? "active" : ""}
          >
            <Link to="/about-us">About</Link>
          </li>
          <li
            onClick={closeDrawer}
            className={location.pathname === "/contact-us" ? "active" : ""}
          >
            <Link to="/contact-us">Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
